<template>

    <v-toolbar
    dense
    class="pf-bg-teal"
    dark
    style="z-index: 9"
    >
    <v-toolbar-title class="ml-0">
      <router-link :to="{name: 'Root'}">
        <v-avatar size="90%" class="appLogo" width="300px">
          <img 
            :src="logo"
            :alt="logo"
          />
        </v-avatar>
      </router-link>
    </v-toolbar-title>
    <!-- <h4>{{ $route.meta.title }}</h4> -->
      <v-spacer></v-spacer>     
      <!-- <v-btn id="bt_fullscren" icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn> -->
      <!-- <v-menu id="bt_speed" offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon flat slot="activator">
          <v-avatar size="25px">
            <img 
              :src="avatar" 
              :alt="name"
            />
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu> -->
      <span class="pr-3" v-if="session.getSession().adminUser && session.getSession().adminUser.role === 'admin' && session.getSession().user.role === 'parent'"><b>Profile Status :</b> {{`${Account.profile_status ? Account.profile_status.join(' / ') : ''}`}}</span>
      <v-btn @click="backToAdmin" v-if="session.getSession().adminUser && ((session.getSession().adminUser.role === 'agency' && ['parent', 'child'].indexOf(session.getSession().user.role) > -1) || (session.getSession().adminUser.role === 'admin' && ['agency', 'child'].indexOf(session.getSession().user.role) > -1))" class="grey lighten-2 pf-text-teal">
        <!-- <v-icon>power_settings_new</v-icon> -->
        <span>Go back to {{`${session.getSession().adminUser.role}`}} dashboard</span>
      </v-btn>
      <v-menu class="pr-2" :value="shown" v-if="session.getSession().adminUser && session.getSession().adminUser.role === 'admin' && session.getSession().user.role === 'parent'" offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on }">
        <v-btn icon small class="mr-0 ml-0" v-on="on" @click="shown=true">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon size="22" v-on="on">apps</v-icon>
            </template>
            <span>Options</span>
          </v-tooltip>
        </v-btn>
        </template>
        <v-list class="pb-0">
          <v-list-tile @click="backToAdmin">
            <v-list-tile-action>
              <v-btn icon small class="mr-0 ml-0">
                <v-icon size="22" color="grey darken-2">keyboard_backspace</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title>
              Go back to Admin dashboard
            </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="messageAddPage">
            <v-list-tile-action>
              <v-btn icon small class="mr-0 ml-0">
                <v-icon size="22" color="grey darken-2">message</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title >
              Send message
            </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="noteAddPage">
            <v-list-tile-action>
              <v-btn icon small class="mr-0 ml-0">
                <v-icon size="22" color="grey darken-2">note_add</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-content>
            <v-list-tile-title >
              Add Note
            </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-list class="pt-0">
            <v-list-group
             id="menu"
              v-for="item in itemList"
              :key="item.title"
              v-model="menu"
              prepend-icon="local_activity"
              no-action
            >
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile @click="statusChange(subItem.title); menu=true"
                v-for="subItem in item.items"
                :key="subItem.title"
              > 
                 <v-list-tile-content class="flex-row">
                  <v-list-tile-title :class="Account.profile_status && Account.profile_status.indexOf(subItem.title) > -1 ? 'colorText': ''">{{ subItem.title }}</v-list-tile-title>
                  <v-icon title="Add" v-if="Account.profile_status && Account.profile_status.indexOf(subItem.title) === -1" size="20" class="ml-2 pf-text-teal">add_circle</v-icon>
                  <v-icon title="Remove" v-if="Account.profile_status && Account.profile_status.indexOf(subItem.title) > -1" size="20" class="ml-2 pf-text-red">cancel</v-icon>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-menu>
      <v-btn id="bt_country" icon>
        <!-- <v-icon>flag</v-icon> -->
        <v-avatar size="25px">
          <img 
            :src="flag"
            :alt="flag"
          />
        </v-avatar>
      </v-btn>
      <v-btn id="bt_fullscren" :to="{ name: 'Logout' }" icon>
        <v-icon>power_settings_new</v-icon>
      </v-btn>
      <!-- <v-menu id="menu_notification" offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
        </v-btn>
        <notification-list></notification-list>
      </v-menu> -->
  </v-toolbar>
  

</template>
<script>
/* global session config store */
import NotificationList from '@/components/widgets/list/NotificationList';
import { update } from '../helpers/helpers';
import Util from '@/util';
import { mapGetters } from 'vuex';
import swal from 'sweetalert2';
// This is the app toolbar at the top
export default {
  name: 'app-toolbar',
  components: {
    NotificationList
  },
  data: () => ({
    // @vuese
    // Testing
    session: session,
    menu: false,
    shown: false,
    logo: '/static/logo.png',
    flag: '/static/icon/flag.png',
    avatar: '/static/avatar/a4.jpg',
    name: '',
    itemList: [
      {
        action: 'local_activity',
        title: 'Change profile status',
        items: [
          { title: 'Open' },
          { title: 'New' },
          { title: 'Layout' },
          { title: 'Video' },
          { title: 'Writing' },
        ]
      }
    ],
    items: [
      {
        icon: 'account_circle',
        href: '/#/account-info',
        title: 'My Account',
        click: (e) => { }
      },
      /** {
        icon: 'settings',
        href: '#',
        title: 'Settings',
        click: (e) => {
          console.log(e);
        }
      }, */
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (e) => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  computed: {
    ...mapGetters(['Account', 'Agency']),
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    messageAddPage () {
      this.shown = false;
      this.$router.push({ name: 'adminParentMessageAdd', query: { preUrl: 'Messages' }});
    },
    noteAddPage () {
      this.shown = false;
      // eslint-disable-next-line handle-callback-err
      this.$router.push({ name: 'AddNotes' }).catch(err => {
        //
      }); 
    },
    async statusChange (changeStatus) {
      this.shown = false;
      let index = this.Account.profile_status.indexOf(changeStatus);
      if (index > -1) {
        this.Account.profile_status.splice(index, 1);
      } else {
        this.Account.profile_status.push(changeStatus);
      }
      this.Account.updated_from = 'default';
      let { error, data, status } = await update('Account', this.Account, session.getSession().user.human.account.id);
      if (error) {
        console.log('error', error);
      } else {
        this.loading = false;
        store.commit('setAccount', data);
        swal.fire({
          type: 'success',
          title: 'Profile status updated successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.menu = false;
          }
        });
      }
     
    },
    // @vuese
    // Used to toggle full screen - Not used now
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    // @vuese
    // Used to goto the admin/agency dashboard in case of login to other's profiles
    backToAdmin () {
      let sessionData = session.getSession();
      if (sessionData.adminUser) {
        delete sessionData.user;
        sessionData.user = sessionData.adminUser;
        delete sessionData.adminUser;
        session.setSession(sessionData, false);
        // window.location.href = config.client;
        location.reload();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
  
  .appLogo img {
    border-radius: 0 !important;
  }
  @media only screen and (max-width: 350px) {
    .appLogo {
      width: 100% !important;
    }
  }

  #menu >>> .v-list__group__header:hover {
    background: white !important;
  }

  #menu >>> .primary--text {
    color: #616161 !important;
  }

  #menu >>> .colorText {
    color: #019d8c !important;
  }


</style>


// WEBPACK FOOTER //
// src/components/AppToolbar.vue